import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasWater = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_water')(jsonQuery));
